'use client'

import { LoginForm } from '@/components/auth/login-form'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { useCoolClubMemberQuery } from '@/hooks/react-query/club/use-club'
import { useUserQuery } from '@/hooks/react-query/user/use-user'
import { usePopup } from '@/providers/popup-provider'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import { UserSheet } from './user-sheet'

const CoolClubPopOver = dynamic(
  () => import('./coolclub-popover').then((mod) => mod.CoolClubPopOver),
  {
    ssr: false,
  }
)

export function UserMenu() {
  const isMobile = useIsMobileClient()

  const { data: user } = useUserQuery()
  const { data: coolClubMember } = useCoolClubMemberQuery()
  const { openPopup } = usePopup()

  const handleShowLoginPopup = () => {
    openPopup(<LoginForm />)
  }

  if (!user || !coolClubMember) {
    return (
      <div className='relative'>
        <button
          data-tracking-level-3={'login'}
          className='flex h-13 w-10.5 cursor-pointer items-center justify-center'
          onClick={handleShowLoginPopup}
        >
          <Image
            src={'/icons/icon-account.svg'}
            alt='account'
            width={20}
            height={20}
          />
        </button>
        <CoolClubPopOver />
      </div>
    )
  }

  if (isMobile)
    return (
      <Link
        className='ml-3 flex h-13 w-10.5 cursor-pointer items-center justify-center outline-none'
        aria-label='Thông tin tài khoản'
        href={'/account'}
        data-tracking-level-3={'account'}
      >
        <Image
          src={coolClubMember?.user_image || '/icons/icon-account.svg'}
          alt='account'
          width={30}
          height={30}
        />
      </Link>
    )

  return <UserSheet user={user} coolClubMember={coolClubMember} />
}
